import React, { Component, Fragment } from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import ReceivingPartNOSInputs from "./receivingPartNOSInputs";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { v4 as uuidv4 } from "uuid";
import {
  defaultTableChange,
  defaultTableChange1,
} from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { initialDataDetail, tableDetailColumns } from "../config";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {
  //   getCategoryType,
  getDataDetail,
  validateDataItem,
  fetchDataItem,
  constructGenSeqPayload,
  getDataDetailView,
} from "../utilUpdate";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import HotlineDetailDataInput from "../hotlineDetailDataInput";
import ReceivingPartNOSPreviewQR from "./receivingPartNOSPreviewQR";

class ReceivingPartNOSDetailView extends Component {
  constructor(props) {
    super(props);
    this.listDataName = { QR: "partWithQR", NOQR: "partWithOutQR" };
    this.listTabPanel = ["QR", "NOQR"];
    this.handlers = {
      handleAddRow: this.handleAddRow,
      handleSaveRow: this.handleSaveRow,
      handleEditRow: this.handleEditRow,
      handleCancelRow: this.handleCancelRow,
      handleDeleteRow: this.handleDeleteRow,
      handleValueChange: this.handleValueChange,
      handleCategoryChange: this.handleCategoryChange,
      handleItemChange: this.handleItemChange,
      handleOrderTypeChange: this.handleOrderTypeChange,
      handleSingleLocatorChange: this.handleSingleLocatorChange,
      handleDetailHotlineVisible: this.handleDetailHotlineVisible,
    };
    this.withQrTableOptions = {
      selectableRows: "multiple",
      serverSide: false,
      ...this.defaultTableSelectedRow(
        this.handleChangePage,
        this.handleChangeRowsPerPage,
        (e) => this.handleOnRowSelected("QR", e),
      ),
    };
    this.state = {
      loading: false,
      warningModalVisible: false,
      activeTab: "QR",
      errorListCabang: undefined,
      errorGracePeriod: undefined,
      errorStartDate: undefined,
      errorEndDate: undefined,
      detailHotlineVisible: false,
      previewQrVisible: false,
      selectedDataQR: null,
      validationErrors: {},
      tableColumn: [],
      dataTable: {
        QR: [],
        NOQR: [],
      },
      dataDetailSaved: [],
      selectedRow: [],
      dataCategory: [],
      dataItem: [],
      dataOrderType: [
        { value: "FIX", label: "Fix" },
        { value: "REGULER", label: "Reguler" },
        { value: "HOTLINE", label: "Hotline" },
        { value: "URGENT", label: "Urgent" },
      ],
      pagination: {
        page: 1,
        limit: 5,
        totalData: 0,
      },
      popupApproval: {
        data: [],
        visible: false,
        isConfirmation: false,
        barcodeNeedApproval: [],
      },
    };
  }

  defaultTableSelectedRow = (
    onChangePage,
    onChangeRowsPerPage,
    onRowsSelected,
  ) => {
    return {
      onChangePage: (currentPage) => {
        if (typeof onChangePage === "function") {
          onChangePage({ page: currentPage });
        }
      },
      onChangeRowsPerPage: (numberOfRows) => {
        if (typeof onChangeRowsPerPage === "function") {
          onChangeRowsPerPage({ rowsPerPage: numberOfRows });
        }
      },

      onRowsSelect: (currentRowsSelected, allRowsSelected) => {
        if (typeof onRowsSelected === "function") {
          const selectedDataIndex = allRowsSelected.map((row) => row.dataIndex);
          onRowsSelected(selectedDataIndex);
        }
      },
    };
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  componentDidMount = async () => {
    try {
      this.handleTriggerLoading();

      await Promise.all([
        this.fetchDataLocator(),
        this.fetchDataSupplier(),
        this.fetchDataSupplierExpedition(),
      ]);

      Object.entries(this.listDataName).forEach(([key, value]) => {
        this.props.setValue(value, this.state.dataDetailSaved[key]);
      });

      console.log(this.props.activityType);

      if (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)) {
        const id = await this.fetchGetNoSPBP();
        console.log(id);

        this.props.setValue("numberOfSPBP", id);
      }

      if (
        R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE) &&
        this.props.initialValues?.receivingPartId
      ) {
        await this.fetchDataDetail();
      }

      const tableColumn = {};
      for (const tab of this.listTabPanel) {
        tableColumn[tab] = tableDetailColumns.detailView({
          handlers: this.handlers,
          state: this.state,
          listCategory: [],
          dataItem: this.state.dataItem,
          dataOrderType: this.state.dataOrderType,
          mode: this.props.mode,
          validationErrors: this.state.validationErrors || {},
        })[tab];
      }

      this.setState((prev) => ({
        ...prev,
        tableColumn,
        validationErrors: prev.validationErrors || {},
      }));
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    } finally {
      this.handleTriggerLoading();
    }
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const { activeTab, dataTable, dataItem, validationErrors } = this.state;

    if (prevState.dataTable !== dataTable) {
      Object.entries(this.listDataName).forEach(([key, value]) => {
        this.props.setValue(value, this.state.dataDetailSaved[key]);
      });
    }
    if (prevState.activeTab !== activeTab) {
      this.handleTriggerLoading();
      this.rebuildColumns();
      this.handleTriggerLoading();
    }

    if (prevState.dataItem !== dataItem) {
      this.rebuildColumns();
    }

    if (prevState.validationErrors !== validationErrors) {
      this.rebuildColumns();
    }
  };

  rebuildColumns = () => {
    const { activeTab, dataItem, dataOrderType, validationErrors } = this.state;

    this.setState((prev) => ({
      tableColumn: {
        ...prev.tableColumn,
        [activeTab]: tableDetailColumns.detailView({
          handlers: this.handlers,
          state: this.state,
          listCategory: [],
          dataItem,
          dataOrderType,
          mode: this.props.mode,
          validationErrors,
        })[activeTab],
      },
    }));
  };

  handleWarningModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      warningModalVisible: !prevState.warningModalVisible,
    }));
  };

  handleSubmitModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      submitModalVisible: !prevState.submitModalVisible,
    }));
  };

  handleOnRowSelected = (tabName, selectedIndexes) => {
    if (tabName !== "QR") return;
    const allData = this.state.dataTable["QR"] || [];
    const selectedData = (selectedIndexes || []).map((index) => allData[index]);

    this.setState({
      selectedRow: selectedData,
    });
  };

  fetchDataLocator = async () => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA",
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.selectedCabang?.value },
        page: null,
        limit: null,
      });

      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataLocator: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSupplierExpedition = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang?.value,
        }),
      });
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplierExpedition: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSupplier = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getSupplierMainDealerBySourceCode,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.selectedCabang?.value,
        }),
      });

      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplier: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleBeforeSubmit = () => {
    let valid = true;

    if (!this.props.validate()) {
      valid = false;
    }

    if (!valid) {
      this.handleWarningModalVisibility(
        "Terdapat field yang belum valid atau belum diisi dengan benar.",
      );
      return;
    }

    const { dataTable } = this.state;
    const allData = [...(dataTable.QR || []), ...(dataTable.NOQR || [])];

    const hasIncomplete = allData.some((item) => item.saved === false);

    if (hasIncomplete) {
      this.handleWarningModalVisibility("Terdapat data yang belum lengkap.");
      return;
    }

    this.handleSubmitModalVisibility();
  };

  handleSubmit = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit(this.props.controls);
    }
  };

  handleAddRow = async () => {
    const { activeTab } = this.state;

    const newData = {
      id: uuidv4(),
      ...initialDataDetail,
      isNew: true,
    };

    this.setState(
      (prevState) => ({
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: [...prevState.dataTable[activeTab], newData],
        },
      }),
      async () => {
        const lastIndex = this.state.dataTable[activeTab].length - 1;
        await this.fetchDataItem(lastIndex);
      },
    );
  };

  handleSaveRow = (index) => {
    const activeTab = this.state.activeTab;
    const rowData = this.state.dataTable[activeTab][index];

    const errors = validateDataItem(rowData);
    if (!R.isEmpty(errors)) {
      this.setState((prev) => ({
        validationErrors: {
          ...prev.validationErrors,
          [activeTab]: {
            ...(prev.validationErrors?.[activeTab] || {}),
            [index]: errors,
          },
        },
      }));
      return;
    }

    this.setState((prev) => {
      const newData = [...prev.dataTable[activeTab]];
      const originalData = prev.originalDataDetail?.[activeTab] || [];

      const originalRow = originalData.find(
        (r) =>
          r.partCode?.value === rowData.partCode?.value &&
          r.purchaseOrderNo === rowData.purchaseOrderNo &&
          r.locatorId?.value === rowData.locatorId?.value,
      );

      const isViolation =
        !rowData.isNew &&
        !!originalRow &&
        originalRow.orderType?.value !== rowData.orderType?.value;
      console.log(originalRow);

      console.log({
        index,
        partCode: rowData.partCode?.value,
        isNew: !!rowData.isNew,
        foundOriginal: !!originalRow,
        originalOrderType: originalRow?.orderType?.value,
        currentOrderType: rowData.orderType?.value,
        isViolation,
      });

      const isDuplicate = prev.dataTable[activeTab].some(
        (item, i) =>
          i !== index &&
          item.partCode?.value === rowData.partCode?.value &&
          item.locatorId?.value === rowData.locatorId?.value,
      );

      if (isDuplicate) {
        this.handleWarningModalVisibility(
          "Data part sudah terdapat pada list.",
        );
        return prev;
      }

      const updatedRow = {
        ...newData[index],
        saved: true,
        isViolation,
      };
      newData[index] = updatedRow;

      const updatedTable = newData.map((item) => {
        if (item.isNew) return { ...item, isViolation: false };
        const origin = originalData.find(
          (r) =>
            r.partCode?.value === item.partCode?.value &&
            r.purchaseOrderNo === item.purchaseOrderNo &&
            r.locatorId?.value === item.locatorId?.value,
        );
        const rowViolation =
          !!origin && origin.orderType?.value !== item.orderType?.value;
        return { ...item, isViolation: rowViolation };
      });

      if (this.props.onViolationChange) {
        const anyViolation = updatedTable.some((r) => r.isViolation);
        this.props.onViolationChange(anyViolation);
      }

      return {
        ...prev,
        dataTable: {
          ...prev.dataTable,
          [activeTab]: updatedTable,
        },
        dataDetailSaved: {
          ...prev.dataDetailSaved,
          [activeTab]: updatedTable,
        },
        validationErrors: {
          ...prev.validationErrors,
          [activeTab]: {
            ...(prev.validationErrors?.[activeTab] || {}),
            [index]: undefined,
          },
        },
      };
    });
  };

  handleEditRow = async (index) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      console.log(newState);

      const savedPrevValue = newState[index];
      console.log(savedPrevValue);
      newState[index] = {
        ...newState[index],
        saved: !newState[index].saved,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
        selectedRow: {
          ...prevState.selectedRow,
          [this.state.activeTab]: {
            ...prevState.selectedRow?.[this.state.activeTab],
            [index]: savedPrevValue,
          },
        },
      };
    });

    const categoryId =
      this.state.dataTable[this.state.activeTab][index].category?.value;
    await this.fetchDataItem(index, categoryId);
  };

  handleCancelRow = (index) => {
    this.setState((prevState) => {
      let dataTable = prevState.dataTable[this.state.activeTab];
      if (
        R.isNil(prevState.selectedRow) ||
        R.isEmpty(prevState.selectedRow) ||
        R.isEmpty(prevState.selectedRow?.[this.state.activeTab])
      ) {
        dataTable = [
          ...prevState.dataTable[this.state.activeTab].filter(
            (_, idx) => idx !== index,
          ),
        ];
      } else {
        dataTable[index] = Object.values(
          prevState.selectedRow[this.state.activeTab],
        ).find((item) => item.id === dataTable[index].id);
      }

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: dataTable,
        },
        selectedRow:
          !R.isNil(prevState.selectedRow) && !R.isEmpty(prevState.selectedRow)
            ? {
                ...prevState.selectedRow,
                [this.state.activeTab]: Object.values(
                  prevState.selectedRow[this.state.activeTab],
                ).filter((item) => item.id !== dataTable[index].id),
              }
            : null,
      };
    });
  };

  handleDeleteRow = (index) => {
    this.setState((prevState) => ({
      ...prevState,
      dataTable: {
        ...prevState.dataTable,
        [this.state.activeTab]: [
          ...prevState.dataTable[this.state.activeTab].filter(
            (_, idx) => idx !== index,
          ),
        ],
      },
      dataDetailSaved: {
        ...prevState.dataDetailSaved,
        [this.state.activeTab]: [
          ...prevState.dataDetailSaved[this.state.activeTab].filter(
            (_, idx) => idx !== index,
          ),
        ],
      },
    }));
  };

  handleValueChange = (index, name, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      newState[index] = {
        ...newState[index],
        [name]: value,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
      };
    });
  };

  handleCategoryChange = async (index, name, value) => {
    this.setState((prevState) => {
      const newState = [...prevState.dataTable[this.state.activeTab]];
      newState[index] = {
        ...newState[index],
        [name]: value,
        name: null,
        kode: null,
        satuan: null,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [this.state.activeTab]: newState,
        },
      };
    });

    this.handleTriggerLoading();
    await this.fetchDataItem(index, value.value);
    this.handleTriggerLoading();
  };

  handleDetailHotlineVisible = () => {
    console.log("cek");

    this.setState((prevState) => ({
      ...prevState,
      detailHotlineVisible: !prevState.detailHotlineVisible,
    }));
  };

  handleSelectHotline = (value) => {
    const { tab } = this.props;
    this.setValueObject(tab, value);
    this.handleDetailHotlineVisible();
  };

  setValueObject = (tab, value) => {
    this.props.onSetState((prevState) => ({
      ...prevState,
      data: {
        ...prevState.data,
        [tab]: {
          ...prevState.data[tab],
          ...value,
        },
      },
    }));
  };

  handleItemChange = (index, name, value) => {
    this.setState((prevState) => {
      const activeTab = this.state.activeTab;
      const newData = [...prevState.dataTable[activeTab]];

      const selectedPart = value;

      newData[index] = {
        ...newData[index],
        partCode: selectedPart,
        partName: selectedPart,
        kode: selectedPart?.value || "",
        satuan: selectedPart?.satuan || "",
        categoryName: selectedPart?.partCategory || newData[index]?.kategori,
        saved: false,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: newData,
        },
      };
    });
  };

  handleOrderTypeChange = (index, value) => {
    this.setState((prevState) => {
      const activeTab = prevState.activeTab;
      const newData = [...prevState.dataTable[activeTab]];

      newData[index] = {
        ...newData[index],
        orderType: value,
        saved: false,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: newData,
        },
      };
    });
  };

  handleSingleLocatorChange = (index, value) => {
    this.setState((prevState) => {
      const activeTab = prevState.activeTab;
      const newData = [...prevState.dataTable[activeTab]];

      newData[index] = {
        ...newData[index],
        locatorId: value,
        saved: false,
      };

      return {
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          [activeTab]: newData,
        },
      };
    });
  };

  handleTabChange = (index) => {
    const tabName = this.listTabPanel[index];

    this.setState((prev) => ({
      ...prev,
      activeTab: tabName,
      pagination: {
        ...prev.pagination,
        page: 1,
        limit: 5,
      },
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchGetNoSPBP = async () => {
    let payload = constructGenSeqPayload(this.props.selectedCabang?.value);
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave(
        payload,
      );
      return res.ok ? res.data : null;
    } catch (error) {
      console.log("error: ", error);
    }
  };

  fetchDataDetail = async () => {
    const id = this.props.initialValues.receivingPartId;

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getReceivingPartNOSById,
      menuName: "Master Receiving Part H2",
      setError: this.props.setError,
      args: contructQueryParam({ receivingPartId: id }),
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data?.data;
      console.log(data);

      this.props.setValue("id", data?.id);
      this.props.setValue("receivingPartId", data?.receivingPartId);
      this.props.setValue("numberOfSPBP", data?.numberOfSPBP);
      this.props.setValue("invoiceNo", data?.invoiceNo);
      this.props.setValue("receivedNo", data?.receivedNo);
      this.props.setValue("note", data?.note);
      this.props.setValue("carId", data?.carId);

      const supplier = data?.supplier;
      this.props.setValue(
        "supplierId",
        supplier
          ? {
              value: supplier.supplierCode,
              label: supplier.supplierName,
              name: supplier.supplierName,
            }
          : null,
      );

      const supplierExp = data?.expedition;
      this.props.setValue(
        "expeditionId",
        supplierExp
          ? {
              value: supplierExp.supplierCode,
              label: supplierExp.supplierName,
              name: supplierExp.supplierName,
            }
          : null,
      );

      const dataQR = getDataDetailView("QR", data.partWithQR);
      const dataNOQR = getDataDetailView("NOQR", data.partWithOutQR);

      const originalQR = JSON.parse(JSON.stringify(dataQR));
      const originalNOQR = JSON.parse(JSON.stringify(dataNOQR));

      this.setState((prevState) => ({
        ...prevState,
        dataTable: {
          ...prevState.dataTable,
          QR: dataQR,
          NOQR: dataNOQR,
        },
        dataDetailSaved: {
          ...prevState.dataDetailSaved,
          QR: dataQR,
          NOQR: dataNOQR,
        },
        originalDataDetail: {
          QR: originalQR,
          NOQR: originalNOQR,
        },
      }));
    }
  };

  fetchDataCategory = async (body) => {
    try {
      const res = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam(
        body,
      );
      if (res.ok) {
        return res.data.data;
      }
    } catch (error) {
      console.log("errors: ", error);
    }

    return null;
  };

  fetchDataItem = async (index, categoryId) => {
    try {
      const res = await fetchDataItem(this.state.activeTab, categoryId);
      const data = Array.isArray(res) ? res : [];

      this.setState((prevState) => {
        const { activeTab } = prevState;

        return {
          dataItem: {
            ...prevState.dataItem,
            [activeTab]: {
              ...(prevState.dataItem?.[activeTab] || {}),
              [index]: data,
            },
          },
        };
      });

      return data;
    } catch (error) {
      console.error("Error fetching data item:", error);
      return [];
    }
  };

  // handlePreviewQrVisibility = async (action) => {
  //   const selectedRow = Array.isArray(this.state.selectedRow)
  //     ? this.state.selectedRow
  //     : [];

  //   this.handleTriggerLoading(true);

  //   try {
  //     if (action === "generate") {
  //       if (!selectedRow || selectedRow.length === 0) {
  //         this.handleWarningModalVisibility(
  //           "Data belum di ceklis, harap pilih data terlebih dahulu untuk dicetak."
  //         );
  //         return;
  //       }

  //       const payload = this.constructToQRReportItem(selectedRow);

  //       const res = await Api.create(
  //         "NAGAMAS_REPORT"
  //       ).generateQRReceivingUnitKSU(payload);
  //       console.log(res);

  //       if (res.ok) {
  //         // Optional update print count
  //         // if (payload.length > 0) await this.fetchUpdateNumberOfPrintQRCode();

  //         this.setState((prevState) => ({
  //           ...prevState,
  //           PDF: URL.createObjectURL(res.data),
  //           previewQrVisible: true,
  //         }));
  //       } else {
  //         this.handleWarningAlertVisibility(
  //           "ERROR",
  //           res.data?.message || "Gagal generate QR Code."
  //         );
  //       }
  //     }

  //     if (action === "close") {
  //       this.setState((prevValue) => ({
  //         ...prevValue,
  //         selectedDataQR: [],
  //         previewQrVisible: false,
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error generate QR:", error);
  //     this.handleWarningAlertVisibility(
  //       "ERROR",
  //       "Terjadi kesalahan saat generate QR."
  //     );
  //   } finally {
  //     this.handleTriggerLoading(false);
  //   }
  // };

  handlePreviewQrVisibility = async (action) => {
    this.handleTriggerLoading(true);

    try {
      if (action === "generate") {
        const selectedRow = Array.isArray(this.state.selectedRow)
          ? this.state.selectedRow
          : [];

        if (selectedRow.length === 0) {
          this.handleWarningModalVisibility(
            "Data belum di ceklis, harap pilih data terlebih dahulu untuk dicetak.",
          );
          return;
        }

        await this.validateQRCodePrintApprovalPart(selectedRow);
      }

      if (action === "close") {
        this.setState((prev) => ({
          ...prev,
          selectedRow: [],
          previewQrVisible: false,
        }));
      }
    } catch (err) {
      console.error(err);
      this.handleWarningAlertVisibility("ERROR", "Gagal memproses Print QR.");
    } finally {
      this.handleTriggerLoading(false);
    }
  };

  validateQRCodePrintApprovalPart = async (selectedRow) => {
    console.log(selectedRow);

    const userId = localStorage.getItem("userId");
    const { selectedCabang, controls } = this.props;

    const payload = {
      trxId: controls.shippingNo?.value,
      kodeCabang: selectedCabang?.value,
      idUserPemohon: userId,
      module: "RECEIVING_PART",
      listBarcode: selectedRow.map((item) => item.barcode?.partBarcode),
    };
    console.log(payload);

    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkPrintQRKSUApproval,
      menuName: "Receiving Part ",
      setError: this.props.setError,
      args: payload,
    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const { listBarcodeToPrint, listBarcodeNeedApproval, listIdRequest } =
        response.data.data;

      if (listBarcodeToPrint) {
        await this.fetchGenerateQRCodePart(selectedRow);
      } else {
        this.handlePopupAlertVisibility(
          listBarcodeNeedApproval || listIdRequest,
          listBarcodeNeedApproval,
        );
      }
    } else {
      throw new Error(response.data.message);
    }
  };

  fetchGenerateQRCodePart = async (selectedRow) => {
    try {
      const reqBody = this.constructToQRReportItem(selectedRow);
      const res =
        await Api.create("NAGAMAS_REPORT").generateQRReceivingUnitKSU(reqBody);

      if (res.ok) {
        if (reqBody.length > 0) {
          await this.fetchUpdateNumberOfPrintQRCodePart(selectedRow);

          this.setState((prev) => ({
            ...prev,
            previewQrVisible: true,
            PDF: URL.createObjectURL(res.data),
          }));
        }
      } else {
        this.handleWarningAlertVisibility(
          "ERROR",
          res.data?.message || "Gagal generate QR Code.",
        );
      }
    } catch (err) {
      console.error("Error generate QR Part:", err);
    }
  };

  fetchUpdateNumberOfPrintQRCodePart = async (selectedRow) => {
    try {
      const reqBody = selectedRow.map((item) => item.barcode?.partBarcode);

      await Api.create("NAGAMAS_TRANSACTION").updateNumberOfPrintQRCodePartNOS(
        reqBody,
      );
    } catch (err) {
      console.error("Error update print count part:", err);
    }
  };

  handlePopupAlertVisibility = (data, barcodeNeedApproval) => {
    this.setState((prev) => ({
      popupApproval: {
        data: data || [],
        visible: !prev.popupApproval.visible,
        isConfirmation: Boolean(barcodeNeedApproval),
        barcodeNeedApproval: barcodeNeedApproval || [],
      },
    }));
  };

  constructToQRReportItem = (selectedRows) => {
    const qrList = [];

    selectedRows.forEach((row) => {
      const itemName = row.partName?.label || row.partName || "-";
      const barcodes = Array.isArray(row.barcode) ? row.barcode : [row.barcode]; // <-- fix di sini

      barcodes.forEach((bc) => {
        if (bc) {
          qrList.push({
            itemName: itemName,
            qrCode: bc.barcodeEncrypted,
            qrCodeRaw: bc.partBarcode,
          });
        }
      });
    });

    return qrList;
  };

  renderAlertApproval = () => {
    const { popupApproval } = this.state;
    const isConfirmation = popupApproval.isConfirmation;
    const title = isConfirmation ? "Konfirmasi" : "Informasi";
    const subTitle = isConfirmation
      ? "Cetak ulang QR dengan no QR:"
      : "Pengajuan tidak dapat dilakukan sebelum pengajuan dengan No. Request: ";
    const desc = isConfirmation
      ? "Apakah anda yakin?"
      : "dilakukan keputusan APPROVE/REJECT";
    return (
      <SimpleAlert
        title={title}
        visible={popupApproval.visible}
        onClickClose={() => this.handlePopupAlertVisibility()}
        content={
          <div style={{ textAlign: "left" }}>
            <p style={{ marginBottom: "10px" }}>{subTitle}</p>
            <FlexView
              style={{ gap: "10px", maxHeight: "200px", overflowY: "auto" }}
            >
              <ul
                style={{
                  listStyleType: "circle",
                  paddingLeft: "20px",
                }}
              >
                {popupApproval.data.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </FlexView>
            <p style={{ marginTop: "10px" }}>{desc}</p>
          </div>
        }
        additionalButtons={
          isConfirmation ? (
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
                TIDAK
              </SimpleButton>
              <SimpleButton onClick={this.createApprovalQRPrint}>
                YA
              </SimpleButton>
            </FlexView>
          ) : (
            <SimpleButton onClick={() => this.handlePopupAlertVisibility()}>
              OK
            </SimpleButton>
          )
        }
      />
    );
  };

  createApprovalQRPrint = async () => {
    const { popupApproval } = this.state;
    const { controls, selectedCabang } = this.props;
    const userId = localStorage.getItem("userId");

    this.handleTriggerLoading();

    const payload = {
      trxId: controls.shippingNo.value,
      kodeCabang: selectedCabang?.value,
      idUserPemohon: userId,
      module: "RECEIVING_PART",
      listBarcode: popupApproval.barcodeNeedApproval || [],
    };
    console.log(payload);

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").createApprovalPrint,
      menuName: "Receiving PART",
      setError: this.props.setError,
      args: payload,
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handlePreviewQrVisibility("close");
      this.handlePopupAlertVisibility();
    }
  };

  render() {
    const { pagination } = this.state;
    return (
      <>
        <SimpleModal
          title="Detail View Penerimaan Part - NOS"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <ReceivingPartNOSInputs
                {...this.props}
                activityRead={this.state.activityRead}
                dataSupplier={this.state.dataSupplier}
                dataSupplierExpedition={this.state.dataSupplierExpedition}
              />

              {this.props.mode != "view" && (
                <FlexView vAlignContent="center" className="margin-bottom-10px">
                  <SimpleButton
                    className={"btn btn-plus background-red margin-left-none"}
                    onClick={this.handleAddRow}
                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                    text={"Tambah"}
                  />
                </FlexView>
              )}

              <Tabs onSelect={this.handleTabChange}>
                <TabList>
                  {this.listTabPanel.map((tab, index) => (
                    <Tab key={index}>
                      {R.equals(tab, "QR") ? "Dengan QR" : "Tanpa QR"}
                    </Tab>
                  ))}
                </TabList>

                {this.listTabPanel.map((tab, index) => (
                  <TabPanel key={tab}>
                    <SimpleDataTable
                      key={`${pagination.totalData}-${pagination.page}`}
                      data={this.state.dataTable[tab]}
                      columns={this.state.tableColumn[tab] || []}
                      toCount={this.state.dataTable[tab].length}
                      rowsPerPage={pagination.limit}
                      page={pagination.page - 1}
                      options={
                        tab === "QR"
                          ? {
                              ...this.withQrTableOptions,
                              ...defaultTableChange(
                                this.handleChangePage,
                                this.handleRowsPerPage,
                              ),
                              serverSide: false,
                            }
                          : {
                              ...defaultTableChange(
                                this.handleChangePage,
                                this.handleRowsPerPage,
                              ),
                              serverSide: false,
                            }
                      }
                      // options={
                      //   tab === "QR"
                      //     ? this.withQrTableOptions
                      //     : { ...defaultTableChange() }
                      // }
                    />
                  </TabPanel>
                ))}
              </Tabs>

              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <SimpleButton
                  text="Print QR"
                  type="button"
                  onClick={() => this.handlePreviewQrVisibility("generate")}
                />
              </div>
            </ModalContainer>
          }
        />

        {this.state.warningModalVisible && (
          <SimpleAlert
            title={
              this.state.warningType === "warning"
                ? "Peringatan"
                : "Information"
            }
            content={
              <div>
                <p>
                  {this.state.warningMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            additionalButtons={
              <Fragment>
                <FlexView>
                  <SimpleButton
                    text="OK"
                    onClick={() => this.handleWarningModalVisibility()}
                  />
                </FlexView>
              </Fragment>
            }
            visible={this.state.warningModalVisible}
            onClickClose={this.handleWarningModalVisibility}
          />
        )}

        {this.state.submitModalVisible && (
          <SimpleAlert
            title={"Confirmation"}
            content={"Apakah anda yakin ingin menyimpan data ini?"}
            visible={this.state.submitModalVisible}
            onClickClose={this.handleSubmitModalVisibility}
            onSubmit={this.submitModalVisible}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Batal"
                  onClick={() => this.handleSubmitModalVisibility()}
                />
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="Iya"
                  onClick={() => this.handleSubmit()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.detailHotlineVisible && (
          <HotlineDetailDataInput
            // {...this.props}
            visible={this.state.detailHotlineVisible}
            title="Cari No. Hotline"
            onSelect={this.handleSelectHotline}
            onClickClose={this.handleDetailHotlineVisible}
          />
        )}
        {this.state.previewQrVisible && (
          <ReceivingPartNOSPreviewQR
            PDF={this.state.PDF}
            visible={this.state.previewQrVisible}
            onPreviewQr={() => this.handlePreviewQrVisibility("close")}
            onStateChange={this.handleStateChange}
          />
        )}
        {this.renderAlertApproval()}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default withFormGroup(ReceivingPartNOSDetailView);
